<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm hệ điều hành phiên bản</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Phiên bản" placeholder="Nhập phiên bản" [formGroup]="searchForm" formControlName="versionLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="systemVersionStatusOptionList"></app-input-select>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchSystemVersion()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">version</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" (click)="insertSystemVersion()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="devSystemVersionList && !loading">
                <tr *ngFor="let devSystemVersion of devSystemVersionList;index as devSystemVersionIndex">
                    <td scope="col">{{(devSystemVersionPagination.currentPage-1)*devSystemVersionPagination.pageSize + devSystemVersionIndex+1}}</td>
                    <td scope="col">{{devSystemVersion.version}}</td>
                    <td scope="col">{{systemVersionStatusOptionMap[devSystemVersion.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewSystemVersion(devSystemVersion)">Xem</button>
                            <button type="button" class="btn btn-primary" (click)="editSystemVersion(devSystemVersion)">Sửa</button>
                            <button type="button" class="btn btn-danger"  (click)="deleteSystemVersion(devSystemVersion)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="devSystemVersionPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':devSystemVersionPagination.currentPage == 1}">
                      <a class="page-link" (click)="devSystemVersionPageChange(devSystemVersionPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="devSystemVersionPagination.currentPage > 3">
                      <a class="page-link" (click)="devSystemVersionPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="devSystemVersionPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of devSystemVersionPagination.pageList"  [ngClass]="{'active':devSystemVersionPagination.currentPage == page}">
                    <a class="page-link" (click)="devSystemVersionPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="devSystemVersionPagination.currentPage < devSystemVersionPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="devSystemVersionPagination.currentPage < devSystemVersionPagination.pageCount - 2">
                    <a class="page-link" (click)="devSystemVersionPageChange(devSystemVersionPagination.pageCount)">{{devSystemVersionPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':devSystemVersionPagination.currentPage == devSystemVersionPagination.pageCount}">
                    <a class="page-link"  (click)="devSystemVersionPageChange(devSystemVersionPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Trở về</button>
        </div>
        </div>
    </div>
</div>

